import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/header/styles.scss';export default {
  "header": "_header_o3olu_1",
  "label": "_label_o3olu_13",
  "resource": "_resource_o3olu_20",
  "center": "_center_o3olu_25",
  "removeAllocation": "_removeAllocation_o3olu_29",
  "actions": "_actions_o3olu_34"
};